import React from 'react';
import { ArtGallery } from '../../features/ArtEditor';
import { STUDIO_FORMATS, formatAvailable } from '../../enums/formats';

const GALLERY_FORMATS = ['instagram::post', 'instagram::carousel', 'instagram::stories'];

// The template gallery (features/ArtEditor's ArtGallery) on the Studio's data, opened from
// the home prompt: a pick goes into the draft as its template. Formats not offered yet stay
// listed as "soon".
export default function ArtGalleryDialog({ studio: s }) {
  const { t } = s;
  const close = () => s.setModal(null);
  if (!s.art?.gallery) return null;
  const formats = GALLERY_FORMATS.map(id => STUDIO_FORMATS.find(format => format.id === id)).filter(Boolean)
    .map(format => ({ id: format.id, label: `Instagram · ${t(format.labelKey)}`, available: formatAvailable(format, s.capabilities) }));
  return <ArtGallery open onClose={close} source={s.art.gallery} format={s.entry.format || 'instagram::post'} formats={formats} onPick={s.chooseArtTemplate}
    selectedId={s.entry.art?.template?.id} title={t('artGalleryTitle')} />;
}
